import { DashboardPeriod } from '@Types/dashboard';
import { useTranslation } from 'react-i18next';

import { useDashboardDaysStore } from '../../../../models/useDashboardDaysModel';
import DashboardLayout from '../../Layout/DashboardLayout';
import TimeRangeSelector from '../../TimeRangeSelector';
import { useExpandSection } from '../useExpandSection';
import BecDetections from './BecDetections';
import BecTopCompromisedUsers from './BecTopCompromisedUsers';
import BecTopRecipients from './BecTopRecipients';
import BecTopWSViolations from './BecTopWSViolations';

function Bec() {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();
  const { data, isExpanded, isLoading, onExpandChange, isError, refetch } =
    useExpandSection({
      section: 'bec',
      period: daysModel.days.DashboardBec as DashboardPeriod,
    });

  return (
    <DashboardLayout
      title={t('dashboard.sideBar.bec')}
      titleBar={<TimeRangeSelector widgetId="DashboardBec" />}
      barColor="#BDB4FB"
      expanded={isExpanded}
      onExpandChange={onExpandChange}
      loading={isLoading}
      loadingFailed={isError}
      onRetryLoading={refetch}
    >
      <BecDetections data={data} day={daysModel.days['DashboardBec']} />
      <BecTopRecipients data={data} day={daysModel.days['DashboardBec']} />
      <BecTopWSViolations data={data} day={daysModel.days['DashboardBec']} />
      <BecTopCompromisedUsers
        data={data}
        day={daysModel.days['DashboardBec']}
      />
    </DashboardLayout>
  );
}

export default Bec;
